// extracted by mini-css-extract-plugin
export default {"round":"AddToCart_round__PkR-P","add":"AddToCart_add__m89I8","border":"AddToCart_border__8RN+d"};